import React, { useMemo, useState } from "react";
import { useHistory } from "react-router";
import { CardContent, CardActions, Button} from "@deere/fuel-react";
import { GridRowModes, GridActionsCellItem,useGridApiRef} from '@mui/x-data-grid';
import { ST_ADMIN_CASES } from '../../utils/surveyLiterals';
import { LikeNameContent } from './LikeNameContent'
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/EditOutlined';
import LinkIcon from '@mui/icons-material/LinkOutlined';
import CreateIcon from '@mui/icons-material/AddOutlined';
import MoreIcon from '@mui/icons-material/MoreVertOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {SUBTIER_MENU_ACTIONS,GRAL_NAVIGATION,SUBTIER_ADMIN_TITLE,GRAL_VALIDATION_MSGS,GRAL_ALERT_SEVERITIES} from "../../utils/constants";
import {SubtierModal} from '../../components/modals/SubtierModal'
import {linkSubtierMaster, saveSubtierMasterData,saveSubtierRecords, createSubtierSupplierRelation} from "../../services/survey.service";
import { useOktaAuth } from '@okta/okta-react'
import { DataGridPro } from '@mui/x-data-grid-pro';
import {GenericFuelModal} from '../../components/modals/GenericFuelModal';
import {GoldenRecordModal} from '../../components/modals/GoldenRecordModal';
import PositionedSnackbarAlert from '../../components/PositionedSnackbarAlert.js'
import {useUserInfo} from '../../providers/userProvider.js';
import {getExtraGoldenRecordFields} from '../../utils/cleansingUtils.js';

export default function STAdminPanel({ stType, rowsData, deleteFunction, actionButton, actionFunction,removeFunction, countryList,isUnique, setRefreshMasterData }) {
  const { authState } = useOktaAuth();
  const apiRef = useGridApiRef();
  const history = useHistory();
  const [columns, setColumns] = useState([])
  const [showModal, setShowModal] = useState(false);
  const [showGoldenRecordModal, setShowGoldenRecordModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([])
  const [subtier, setSubtier] = React.useState(null);
  const [contextMenu, setContextMenu] = React.useState(null);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const likeNameCardContent = <LikeNameContent rows={rowsData ? rowsData : []} deleteSelectedRow={actionFunction} setRefreshMasterData={setRefreshMasterData}/>
  const rowModesModel = {}
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('success');
  const userInfo = useUserInfo();
  const createdBy = userInfo? userInfo.userID : '';

  useMemo(() => {
    setColumns([
      {
        field: 'supplierNo',
        headerName: 'Supplier No.',
        width: 110,
        editable: false
      },
      {
        field: 'supplierName',
        headerName: 'Supplier Name',
        width: 135,
        editable: false,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'subtierSupplierName',
        headerName: 'Subtier Supplier Name',
        width: 180,
        editable: false,
      },
      {
        field: 'streetAddress',
        headerName: 'Street Address',
        width: 190,
        editable: false,
      },
      {
        field: 'country',
        headerName: 'Country',
        width: 100,
        editable: false,
      },
      {
        field: 'city',
        headerName: 'City',
        width: 100,
        editable: false,
      },
      {
        field: 'state',
        headerName: 'State',
        width: 100,
        editable: false,
      },
      {
        field: 'postalCode',
        headerName: 'Postal Code',
        width: 100,
        editable: false,
      },
      {
        field: 'tierLevel',
        headerName: 'Tier Level',
        editable: false,
      },
      {
        field: 'productType',
        headerName: 'Product Type',
        editable: false,
      },
      {
        field: 'isDiverseEnterprise',
        headerName: 'Is this entity considered a diverse enterprise?',
        editable: false,
      },
      {
        field: 'actions',
        type: 'actions',
        headerName: 'Actions',
        width: 70,
        cellClassName: 'actions',
        getActions: ({ id }) => {
          const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

          if (isInEditMode) {
            return [
              <GridActionsCellItem
                icon={<SaveIcon />}
                label="Save"
                sx={{
                  color: 'primary.main',
                }}
              />,
              <GridActionsCellItem
                icon={<CancelIcon />}
                label="Cancel"
                className="textPrimary"
                color="inherit"
              />,
            ];
          }

          return [
            <GridActionsCellItem
              icon={<MoreIcon />}
              label="More"
              color="inherit"
              onClick={(e)=>openContextMenu(e,id)}
            />
          ];
        },
      },
    ])
  }, [])

  const sendSelectedRows = () =>{
    if(isUnique){
      actionFunction(selectedRows);
    }else{
      setShowValidationModal(true);
    }
    
  }

  const handleContextMenu = (event) => {
    event.preventDefault();
    setSelectedRows([Number(event.currentTarget.getAttribute("data-id"))]);
    setContextMenu(
      contextMenu === null
        ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 }
        : null
    );
  };

  const openContextMenu = (e,id) => {
    setSelectedRows([Number(id)]);
    setContextMenu(
      contextMenu === null
        ? { mouseX: e.clientX - 2, mouseY: e.clientY - 4 }
        : null
    );
  };

  const openModal = (id) =>{
    setShowModal(true);
    if(id){
      const tmpGoldenRecord = rowsData.filter((row) => row.id === id);
      if(tmpGoldenRecord){
        setSubtier(tmpGoldenRecord[0]);
      }else{
        setSubtier({});  
      }
    }else{
      setSubtier({});
    }    
  }

  const openGoldenRecordModal = (id) =>{
    setShowGoldenRecordModal(true);
    if(id){
      const tmpGoldenRecord = rowsData.filter((row) => row.id === id);
      if(tmpGoldenRecord){
        setSubtier(tmpGoldenRecord[0]);
      }else{
        setSubtier({});  
      }
    }else{
      setSubtier({});
    }    
  }

  const handleContextMenuClose = () => {
    setContextMenu(null);
  };

  const handleSubmit = async(goldenRecord, goldenRecordExtraFields) =>{
    try{      
      if (goldenRecordExtraFields){
        const mergedData = { ...goldenRecord, ...goldenRecordExtraFields };
        await saveSubtierRecords(authState.accessToken.accessToken,[mergedData]);
      }
      
      await saveSubtierMasterData(authState.accessToken.accessToken,[goldenRecord]);
      removeFunction(goldenRecord.ids,isUnique);
      setSeverity(GRAL_ALERT_SEVERITIES.success)
      setOpenAlert(true);
      setRefreshMasterData(true);
      setMessage(GRAL_VALIDATION_MSGS.succesfully)
      setTimeout(() => {
        setOpenAlert(false);
      }, 4000)
    }catch(e){
      setSeverity(GRAL_ALERT_SEVERITIES.error)
      setOpenAlert(true);
      setMessage(GRAL_VALIDATION_MSGS.error_while_saving)
      setRefreshMasterData(false);
      setTimeout(() => {
        setOpenAlert(false);
      }, 4000)
    }
  } 

  const handleSubmitLink = async(subtierMasterLink) =>{
    try{      
      createSubtierSupplierRelation(subtierMasterLink,authState.accessToken.accessToken).then(response => {
        if(response.status===200){
            const payload = {
                "subtierId": subtierMasterLink.rawSubtierId,
                "surveySubtierId":response.data.surveySubtierId
            }
            linkSubtierMaster(payload,authState.accessToken.accessToken).then(response => {
              removeFunction([subtierMasterLink.rawSubtierId],isUnique);
            }).catch(err => {
              setSeverity(GRAL_ALERT_SEVERITIES.error)
              setOpenAlert(true);
              setMessage(GRAL_VALIDATION_MSGS.survey_link)
              setTimeout(() => {
                  setOpenAlert(false);
              }, 4000)
            })
        }else{
          setSeverity(GRAL_ALERT_SEVERITIES.error)
          setOpenAlert(true);
          setMessage(GRAL_VALIDATION_MSGS.subtier_link)
          setTimeout(() => {
              setOpenAlert(false);
          }, 4000)
        }
    })
    }catch(e){
      setSeverity(GRAL_ALERT_SEVERITIES.error)
      setOpenAlert(true);
      setMessage(GRAL_VALIDATION_MSGS.error_while_saving)
      setTimeout(() => {
        setOpenAlert(false);
      }, 4000)
    }
  } 

  const createFunction = (subtierId) =>{
    const tmpIncomplete = rowsData.find(({id}) => id === subtierId);
    const tmpGoldenRecord = {
      "ids": [tmpIncomplete.id],
      "supplierName": tmpIncomplete.subtierSupplierName,
      "streetAddress": tmpIncomplete.streetAddress,
      "country": tmpIncomplete.country,
      "city": tmpIncomplete.city,
      "state": tmpIncomplete.state,
      "postalCode": tmpIncomplete.postalCode
    }
    const goldenRecordExtraFields = getExtraGoldenRecordFields(tmpIncomplete,createdBy);

    handleSubmit(tmpGoldenRecord,goldenRecordExtraFields); 
  }

  const showDeleteValidation = (show) => {
    setShowValidationModal(show);
  };


  const cardContent = <>
  {openAlert && <PositionedSnackbarAlert message={message} open={openAlert} severity={severity.toLowerCase()} />}
  <CardContent>
    <DataGridPro apiRef={apiRef} 
              sx={{
                height: 450, 
                width: '100%',
                '& .MuiCheckbox-root.Mui-checked': {
                  color: '#367c2b',
                },
                '& .MuiDataGrid-row:hover': {
                    backgroundColor: "#367c2b14",
                },
                '& .MuiDataGrid-row.Mui-selected': {
                  backgroundColor: "#367c2b14",
                  ':hover':{
                    backgroundColor: "#367c2b14",
                  }
                }
              }}
              editMode="row"   
              onRowSelectionModelChange={(ids) => {setSelectedRows(ids);}} 
              loading={rowsData ? false : true} 
              rows={rowsData ? rowsData : []} 
              columns={columns} checkboxSelection
              componentsProps={{
                row: {
                  onContextMenu: handleContextMenu,
                  style: { cursor: "context-menu" }
                }
              }}  
    />
    <CardActions justifyContent="flex-end">
      <Button size="small" variant="secondary" onClick={(e) => history.goBack()}>
        {GRAL_NAVIGATION.BACK}
      </Button>
      <Button size="small" variant="primary" onClick={(e) => sendSelectedRows()}>
        {actionButton}
      </Button>
    </CardActions>
    <Menu
        open={contextMenu !== null}
        onClose={handleContextMenuClose}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu !== null
            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
            : undefined
        }
        componentsProps={{
          root: {
            onContextMenu: (e) => {
              e.preventDefault();
              handleContextMenuClose();
            }
          }
        }}
      >
        <MenuItem onClick={()=>{handleContextMenuClose(); showDeleteValidation(true)}}><DeleteIcon/> {SUBTIER_MENU_ACTIONS.DELETE}</MenuItem>
        <MenuItem onClick={()=>{handleContextMenuClose(); openModal(selectedRows[0]);}}><EditIcon /> {SUBTIER_MENU_ACTIONS.EDIT}</MenuItem>
        <MenuItem onClick={()=>{handleContextMenuClose(); createFunction(selectedRows[0]);}}><CreateIcon/> {SUBTIER_MENU_ACTIONS.CREATE}</MenuItem>
        <MenuItem onClick={()=>{handleContextMenuClose(); openGoldenRecordModal(selectedRows[0]);}}><LinkIcon /> {SUBTIER_MENU_ACTIONS.LINK}</MenuItem>
    </Menu>
    {showModal && <SubtierModal showModal={showModal}  setShowModal={setShowModal} titleModal={'Golden Record'} labelBtnPrimary={'Save'} labelBtnSecondary={'Cancel'} submitFn={handleSubmit} goldenRecord={subtier} countryList={countryList}/>}
    {showGoldenRecordModal && <GoldenRecordModal showModal={showGoldenRecordModal}  setShowModal={setShowGoldenRecordModal} titleModal={'Link to a Golden Record'} labelBtnPrimary={'Save'} labelBtnSecondary={'Cancel'} submitFn={handleSubmitLink} subtier={subtier} />}
    <GenericFuelModal title={SUBTIER_ADMIN_TITLE} 
                              show={showValidationModal}
                              message={GRAL_VALIDATION_MSGS.delete_validation} 
                              secondaryBtn={SUBTIER_MENU_ACTIONS.CANCEL} 
                              primaryButton={SUBTIER_MENU_ACTIONS.DELETE}
                              handleSave={()=>{deleteFunction(selectedRows,isUnique); setShowValidationModal(false);}}
                              handleClose={()=>setShowValidationModal(false)}
            />
  </CardContent>
  </>
  return stType === ST_ADMIN_CASES.LIKENAME ? likeNameCardContent : cardContent;
}
